export enum AdminProfilesEnum {
    Dev = 1,
    Configuracoes = 2,
    Empresas = 3,
    Suporte = 4,
    Sistema = 5,
    Comercial = 6,
    Rede = 7,
}

/** Cargos fixos do admin (admin_cargo) — não personalizáveis, válidos para todos os tipos, inclusive Master. */
export enum AdminCargoEnum {
    Administrador = 1,
    Vendedor = 2,
    Suporte = 3,
    Implantacao = 4,
}

export enum AdminSubPerfilEnum {
    Logs = 1,
    Empresas = 4,
    SuperAcesso = 6,
    UsuariosAdmin = 2,
    Workers = 3,
    UsuariosERP = 5,
    FluxosPadrao = 8,
    Gatilhos = 7,
    leads = 9,
    ExportarDados = 10,
    ExportacaoDados = 11,
    LogsIntegracao = 12,
    Planos = 14,
    NovaEmpresaComercial = 15,
    Distribuidores = 16,
    RelatorioClientes = 17,
    RelatorioDistribuidores = 18,
    Roadmaps = 19,
    Tickets = 20,
    RelatorioSuporte = 21,
}
